import { action } from "typesafe-actions";
import { ExportInfoTypes } from "./types";

export const personalExportLogRequest = () =>
  action(ExportInfoTypes.PERSONAL_EXPORT_LOG_RESQUEST, {});

export const personalExportLogSuccess = () =>
  action(ExportInfoTypes.PERSONAL_EXPORT_LOG_SUCCESS, {});

export const personalExportLogFailure = () =>
  action(ExportInfoTypes.PERSONAL_EXPORT_LOG_FAILURE, {});
